import { Button, Flex, Modal, Segmented, Typography } from 'antd';
import { LuFileText, LuMoon, LuSun } from 'react-icons/lu';

const { Text } = Typography;

const THEME_OPTIONS = [
	{
		value: 'dark',
		label: (
			<Flex align="center" gap={4}>
				<LuMoon /> Dark
			</Flex>
		),
	},
	{
		value: 'light',
		label: (
			<Flex align="center" gap={4}>
				<LuSun /> Light
			</Flex>
		),
	},
];

/**
 * Export options modal for the collection hexagon color-filter — antd
 * counterpart to the model path's `ExportReportModal`. Lets the user pick a
 * PDF theme (DOCX ignores it) and trigger PDF or DOCX generation.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {'light'|'dark'} props.exportTheme
 * @param {(theme: 'light'|'dark') => void} props.setExportTheme
 * @param {(format: 'pdf'|'docx') => void} props.onExport
 * @param {boolean} props.isExporting
 */
const CollectionExportReportModal = ({
	open,
	onClose,
	exportTheme,
	setExportTheme,
	onExport,
	isExporting,
}) => (
	<Modal title="Export Report" open={open} onCancel={onClose} footer={null} destroyOnHidden>
		<Flex vertical gap={16}>
			<Flex vertical gap={4}>
				<Text style={{ fontSize: '0.85rem' }}>Theme (PDF only)</Text>
				<Segmented
					block
					options={THEME_OPTIONS}
					value={exportTheme}
					onChange={setExportTheme}
				/>
			</Flex>

			<Flex vertical gap={8}>
				<Text style={{ fontSize: '0.85rem' }}>Export format</Text>
				<Button
					type="primary"
					icon={<LuFileText />}
					loading={isExporting}
					onClick={() => onExport('pdf')}
					block>
					Export as PDF
				</Button>
				<Button
					icon={<LuFileText />}
					loading={isExporting}
					onClick={() => onExport('docx')}
					block>
					Export as DOCX
				</Button>
			</Flex>
		</Flex>
	</Modal>
);

export default CollectionExportReportModal;
